module.exports = __webpack_public_path__ + "static/media/16.fba33009.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/16.jpg
// module id = 475
// module chunks = 0